import type { I18n } from '@lingui/core';

type Locale = I18n | string;
const localeName = (locale: Locale): string => typeof locale === 'string' ? locale : locale.locale;

/** Dates retain the caller's timezone and precision choices. */
export const formatDate = (locale: Locale, value: Date | number, options?: Intl.DateTimeFormatOptions): string =>
  new Intl.DateTimeFormat(localeName(locale), options).format(value);

export const formatNumber = (locale: Locale, value: number, options?: Intl.NumberFormatOptions): string =>
  new Intl.NumberFormat(localeName(locale), options).format(value);

export const formatRelativeTime = (
  locale: Locale,
  value: number,
  unit: Intl.RelativeTimeFormatUnit,
  options?: Intl.RelativeTimeFormatOptions,
): string => new Intl.RelativeTimeFormat(localeName(locale), options).format(value, unit);
